<template>
  <div class="grid-cards">
    <div v-for="(item, index) in items" :key="`${item.case_id}-${index}`">
      <dispute-grid-card
        :employee-id="employeeId"
        :item="item"
        :disputes-constants="disputesConstants"
        :dispute-lookup-fields="disputeLookupFields"
        :dispute-chargecode-fields="disputeChargecodeFields"
        :resolution-rules="resolutionRules"
        :resolution-rules-loading="resolutionRulesLoading"
        :resolution-modal-loading="resolutionModalLoading"
        :resolution-status-list="resolutionStatusList"
        :resolution-stages-list="resolutionStagesList"
        :resolution-button-values="resolutionButtonValues"
        :is-s-l-a-missed="isSLAMissed"
        :next-status-drop-down-list="nextStatusDropDownList"
        :reason-for-delay-options="reasonForDelayOptions"
        v-on="$listeners" />
    </div>
  </div>
</template>

<script>
// Custom Components
import DisputeGridCard from "@/components/DisputeGridView/DisputeGridCard.vue";

export default {
  name: "DisputeGridView",
  components: {
    DisputeGridCard,
  },
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    employeeId: {
      type: String,
      default: "",
    },
    disputesConstants: {
      type: Object,
      default: () => {},
    },
    disputeLookupFields: {
      type: Object,
      default: () => {},
    },
    disputeChargecodeFields: {
      type: Object,
      default: () => {},
    },
    resolutionRules: {
      type: Object,
      default: () => {},
    },
    resolutionRulesLoading: {
      type: Boolean,
      default: false,
    },
    resolutionModalLoading: {
      type: Boolean,
      default: false,
    },
    resolutionStatusList: {
      type: Array,
      default: () => {},
    },
    resolutionStagesList: {
      type: Array,
      default: () => {},
    },
    resolutionButtonValues: {
      type: Array,
      default: () => {},
    },
    nextStatusDropDownList: {
      type: Array,
      default: () => {},
    },
    isSLAMissed: {
      type: Boolean,
      default: false,
    },
    reasonForDelayOptions: {
      type: Array,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/imports";

.grid-cards {
  display: flex;
  flex-direction: column;
}
</style>
